import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        classifiers: '=',
        query: '=',
        fields: '=',
        departments: '=',
        roles: '=',
        levels: '=',
        defaultFilter: '=',
        lastQuery: '=',
        sites: '='
    },
    template: `
        <div class="block02" ng-class="{ open: vm.filters === true }" ng-if="vm.view !== 'modal'">
            <div class="heading01 theme01">
                <h3 ng-click="vm.changeFilter()">{{ 'filter.Filters' | translate }}</h3>
            </div>
            <div class="table-filters" ng-if="vm.filters === true">
                <form class="form form-filter type02" ng-submit="vm.fetch()">
                    <div class="fields">
                        <div class="row separated row-flex02">
                            <label class="label">{{ 'filter.Site' | translate }}</label>
                            <div class="items">
                                <select ng-model="vm.query.siteId" class="form-control"
                                    ng-options="item.id as item.name for item in vm.sites">
                                    <option value=""></option>
                                </select>
                            </div>
                        </div>
                        <div class="row row-separated">
                            <label class="label">{{ 'report.Course name' | translate }}</label>
                            <div class="items">
                                <input type="text" ng-model="vm.query.name" class="form-control">
                            </div>
                        </div>
                        <div class="row">
                            <label class="label">{{ 'report.Field' | translate }}</label>
                            <div class="items">
                                <select ng-model="vm.query.fieldId" class="form-control"
                                    ng-options="item.id as item.activeI18n.value for item in vm.fields">
                                    <option value=""></option>
                                </select>
                            </div>
                        </div>
                        <div class="row row-separated">
                            <label class="label">{{ 'report.Course department' | translate }}</label>
                            <div class="items">
                                <select ng-model="vm.query.departmentId" class="form-control"
                                    ng-options="item.id as item.value for item in vm.departments">
                                    <option value="">{{ 'course.All departments' | translate }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <label class="label">{{ 'report.Course role' | translate }}</label>
                            <div class="items">
                                <select ng-model="vm.query.roleId" class="form-control"
                                    ng-options="item.id as item.value for item in vm.roles">
                                    <option value="">{{ 'course.All roles' | translate }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <label class="label">{{ 'report.Course level' | translate }}</label>
                            <div class="items">
                                <select ng-model="vm.query.levelId" class="form-control"
                                    ng-options="item.id as item.value for item in vm.levels">
                                    <option value="">{{ 'course.All levels' | translate }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <label class="label">{{ 'filter.Employee status' | translate }}</label>
                            <div class="items">
                                <select class="form-control" ng-model="vm.query.employeeStatus">
                                    <option value=""></option>
                                    <option value="{{ vm.USER_STATUS_ENUM.KEYS.ACTIVE }}">{{ vm.USER_STATUS_ENUM.LABELS.ACTIVE}}</option>
                                    <option value="{{ vm.USER_STATUS_ENUM.KEYS.INACTIVE }}">{{ vm.USER_STATUS_ENUM.LABELS.INACTIVE}}</option>
                                    <option value="{{ vm.USER_STATUS_ENUM.KEYS.NOT_STARTED }}">{{ vm.USER_STATUS_ENUM.LABELS.NOT_STARTED}}</option>
                                </select>
                            </div>
                        </div>
                        <div ng-if="vm.TokenService.isOptionalCoursesModuleEnabled()" class="row row-flex02">
                            <span class="label">{{ 'filter.Include optional' | translate }}</span>
                            <div class="items">
                                <label class="switch01">
                                    <input name="switch" type="checkbox" ng-model="vm.query.includeOptionalTargets">
                                    <span>{{ 'general.Yes' | translate }}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <ul class="actions01">
                        <li><input ng-click="vm.reset()" type="button" class="btn discrete" value="{{ 'report.Reset' | translate }}"></li>
                        <li><input type="submit" class="btn main" value="{{ 'report.Generate report' | translate }}"></li>
                    </ul>
                </form>
            </div>
        </div>
    `
})
export default class {
    constructor (lodash, TokenService, USER_STATUS_ENUM, $window) {
        this.lodash = lodash;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.TokenService = TokenService;
        this.$window = $window;
    }

    $onInit () {
        this.query = angular.copy(this.defaultFilter);

        this.filters = JSON.parse(this.$window.localStorage.getItem('is_courses_report_filter_opened'));
    }

    fetch () {
        this.defaultFilter.includeOptionalTargets = this.query.includeOptionalTargets;
        this.lastQuery = this.lodash.assign({}, this.query);
        this.list.items = [];
        this.list.fetch(this.lodash.assign({}, { expand: 'courseTargetsWithValue,fields,activeI18n' }, this.query));
    }

    changeFilter () {
        this.filters = !this.filters;
        this.$window.localStorage.setItem('is_courses_report_filter_opened', this.filters);
    }

    reset () {
        this.query = {};
        this.fetch();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/courses/filter/index.js